import {ImageRequestParams} from "../models/image/image-request-params";

export class CocaColaPrizeImageRequestParams extends ImageRequestParams {
  constructor(width, color) {
    super({color, width});

    this._resourceName = `bolao26/assets/Coca Cola prize`;
    this.ratio = 3;
    this.c = null;
  }
}
